import React from 'react';
import { useParams } from 'react-router-dom';
import { EditableText, NonIdealState } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import { TorgaContext } from '../TorgaContext';
import { Page } from '../../utils/Layout/Layout';
import {
  actionPersistRoutine,
  actionRoutineAddActivity,
  actionRoutineRemoveActivity,
} from './actions';
import SortableActivityList from '../Activity/SortableActivityList';

export default function Routine() {
  const { state, dispatch, dispatchAction } = React.useContext(TorgaContext);
  let { id: prefixedID } = useParams();
  const id = prefixedID?.slice(1);

  const { [id]: routine } = state.routines.byID;

  if (!routine) {
    return <NonIdealState icon={IconNames.REPEAT} />;
  }

  function handleChange(field, value) {
    dispatch({ type: 'ROUTINE_CHANGE', payload: { id, field, value } });
  }

  function handleConfirm(field, value) {
    dispatchAction(actionPersistRoutine(id, field, value));
  }

  return (
    <Page>
      <h1>
        <EditableText
          placeholder="Routine Name"
          value={routine.name}
          onChange={(e) => handleChange('name', e)}
          onConfirm={(e) => handleConfirm('name', e)}
          selectAllOnFocus={true}
        />
      </h1>

      <p> Build your routine by adding Activities </p>

      <SortableActivityList
        routineID={routine.id}
        activities={routine.activities}
        onActivityAdd={(activity_id) => {
          dispatchAction(actionRoutineAddActivity(routine.id, activity_id));
        }}
        onActivityRemove={(activity_id) => {
          dispatchAction(actionRoutineRemoveActivity(routine.id, activity_id));
        }}
      />
    </Page>
  );
}
